export default __webpack_public_path__ + "static/media/gc_header_logo.0450605c.svg";